<template>
   <v-card>
      <v-card-title>
         {{$t("NOTIFICATIONS")}}
      </v-card-title>
      <v-card-text>
         <div v-for="notification in notifications" :key="notification">
            <v-list-item>
               <v-list-item-content>
                  <v-list-item-title class="h4">({{notification.demandID}}) - {{serverTranslate(notification.scopeName)}}</v-list-item-title>
                  <v-list-item-subtitle class="text--primary">
                   {{notification.sendingDate}}
                  </v-list-item-subtitle>
                  <div>{{notification.messageName}}</div>
               </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
         </div>
         <v-alert v-if="notifications.length == 0">
         <!-- <v-list two-line v-if="notifications.length > 0">
              <template v-for="(notification, index) in notifications">
                <v-list-item :key="notification.demandID">
                    <v-list-item-content>
                      <v-list-item-title>{{notification.demandID}} - {{serverTranslate(notification.scopeName)}}</v-list-item-title>
                      <v-list-item-subtitle class="text--primary">
                        {{notification.sendingDate}}
                      </v-list-item-subtitle>
                      <div v-text="serverTranslate(notification.messageName)"></div>
                    </v-list-item-content>
                </v-list-item>
                <v-divider
                  v-if="index + 1 < notifications.length"
                  :key="index"
                ></v-divider>
              </template>
          </v-list>
         <v-alert v-else> -->
            {{$t("NO_NOTIFICATIONS")}}
         </v-alert>
      </v-card-text>
   </v-card>
</template>
<script>
import serverTranslationsMixin from "@/mixins/serverTranslations.js"
export default {
   mixins: [serverTranslationsMixin],
   data() {
      return {
         notifications:[]
      }
   },
   created() {
      this.getNotifications()
   },
   methods:{
      getNotifications() {
         this.$http.get("/api/users/get_notifications/")
         .then(
            res => {
               this.notifications = res.data.data.notifications
            },
            err => {
               this.$toasted.show(
                 this.serverTranslate(err.response.data.message),
                 {
                   type: "error",
                   icon: "error_outline",
                   theme: "bubble",
                   position: "bottom-left",
                   duration: 3000
                 }
               );
            }
         )
      }
   }
}
</script>
